export enum CPImageSize {
    Default = 0,
    Small = 1,
    Medium = 2,
    Large = 3
}